module.exports = __webpack_public_path__ + "img/chocolate.97a06a41.png";